import { render, staticRenderFns } from "./DocsView.vue?vue&type=template&id=0c32b617&"
import script from "./DocsView.vue?vue&type=script&lang=ts&"
export * from "./DocsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports